import { HttpRequest, HttpResponse } from "@angular/common/http"
import { inject } from "@angular/core"
import { ToastService } from "src/app/data/services/components/toast/toast.service"
import { LogService } from "src/app/data/services/erp/log/log.service"
import { ToastSeverity } from "src/app/domain/enums/components/toast.enum"
import { LogAction, LogFunction, LogModule, LogScreen } from "src/app/domain/enums/erp/log.enum"
import { Toast } from "src/app/domain/interfaces/components/toast.interface"
import { LogAuxiliaryData } from "src/app/domain/models/erp/log/log-auxiliary-data.model"

export class LogAccountsPlanManagement {
  private logService: LogService = inject(LogService)
  private toastService: ToastService = inject(ToastService)

  public generateLog(request: HttpRequest<any>, response: HttpResponse<any>, auxiliaryData: LogAuxiliaryData): void {
    if(response.status !== 200) return

    try {
      switch (auxiliaryData.function) {
        case LogFunction.CREATE_ACCOUNTS_PLAN:
          this.generateLogSaveAccountsPlan(request, response, LogAction.CREATE)
        break
        case LogFunction.EDIT_ACCOUNTS_PLAN:
          this.generateLogSaveAccountsPlan(request, response, LogAction.EDIT)
        break
        case LogFunction.DELETE_ACCOUNTS_PLAN:
          this.generateLogDeleteAccountsPlan(request, response, auxiliaryData.data)
        break
      }
    } catch (error) {
      this.toastService.sendToast({ severity: ToastSeverity.ERROR, message: (error as Error)?.message ?? 'Erro ao gerar log do plano de contas.' } as Toast)
    }
  }

  public generateLogSaveAccountsPlan(request: HttpRequest<any>, response: HttpResponse<any>, logAction: LogAction): void {
    const accountCode: string = request.body?.accountCode ?? request.body?.codCta
    if (!accountCode) return

    const messageLog = `O plano de contas (${accountCode}) foi ${logAction === LogAction.CREATE ? 'criado' : 'editado'}`

    this.logService.create(
      LogModule.REGISTRATION,
      LogScreen.ACCOUNTS_PLAN,
      request.urlWithParams,
      logAction,
      null,
      accountCode,
      messageLog,
      request.body,
      null
    )
  }

  public generateLogDeleteAccountsPlan(request: HttpRequest<any>, response: HttpResponse<any>, auxiliaryData: any): void {
    auxiliaryData?.idsList?.forEach((accountsPlanId: number) => {
      this.logService.create(
        LogModule.REGISTRATION,
        LogScreen.ACCOUNTS_PLAN,
        request.urlWithParams,
        LogAction.DELETE,
        accountsPlanId,
        null,
        `O plano de contas (${accountsPlanId}) foi excluído`,
        request.body
      )
    })
  }
}
